import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit, ViewEncapsulation
} from '@angular/core';

import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { DeviceService, IconSizeEnum, SdBannerComponent, SdIconComponent, SdSkeletonComponent, SkeletonAppearanceEnum } from '@seb/web-design-system/core';

import type { IRecipeUser } from './recipe-user.interface';

@Component({
  selector: 'sd-recipe-user',
  templateUrl: './recipe-user.component.html',
  styleUrls: ['./recipe-user.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdIconComponent,
    SdBannerComponent,
    SdSkeletonComponent,
    TranslateModule
  ]
})
export class SdRecipeUserComponent implements OnInit, OnDestroy {
  constructor(
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
  ) {}

  isMobile$: boolean;
  skeletonAppearanceEnum = SkeletonAppearanceEnum;
  mobileSubscription: Subscription;
  iconSize = IconSizeEnum;

  @Input()
  isLoading = false;

  @Input()
  isSmall = false;

  @Input()
  user: IRecipeUser;

  @Input()
  showRecipeByLabel = true;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.isSmall ? 'is-small' : '',
      this.user.type ? 'is-' + this.user.type?.toLowerCase() : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }
}
